/**
 * RATING TOKENS
 */
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createRatingTokens(s: SemanticTokens) {
  return {
    base: {
      gap: s.layout.padding.xs, // --rating-base-gap
      iconSize: s.iconSizes.base, // --rating-base-icon-size
      transition: s.transition.normal, // --rating-base-transition
    },
    iconFg: s.text.warning, // --rating-icon-fg: var(--text-warning)
    iconFgHover: s.text.warning, // --rating-icon-fg-hover
    iconFgActive: s.text.warning, // --rating-icon-fg-active
  };
}
export const ratingTokens = createRatingTokens(SEMANTIC);
